const config = window.AbdelmegedTheme || {};
const finePointer = window.matchMedia('(pointer: fine)');
const hoverPointer = window.matchMedia('(hover: hover)');
const interactiveSelector = [
  'a',
  'button',
  'input',
  'select',
  'textarea',
  'summary',
  '[role="button"]',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

const reducedMotion = () => document.documentElement.dataset.reducedMotion === 'true';

const canUseCursor = () => (
  config.features?.desktopCursor === true
  && finePointer.matches
  && hoverPointer.matches
  && !reducedMotion()
);

const createCursor = () => {
  const cursor = document.createElement('span');

  cursor.className = 'abdelmeged-custom-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  document.body.append(cursor);

  return cursor;
};

const initCursor = () => {
  if (!canUseCursor() || !document.body) {
    return;
  }

  const cursor = createCursor();
  let targetX = -100;
  let targetY = -100;
  let currentX = targetX;
  let currentY = targetY;
  let scale = 1;

  const render = () => {
    currentX += (targetX - currentX) * 0.18;
    currentY += (targetY - currentY) * 0.18;
    cursor.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%) scale(${scale})`;
    window.requestAnimationFrame(render);
  };

  const setInteractive = (isInteractive) => {
    scale = isInteractive ? 1.42 : 1;
    cursor.classList.toggle('is-interactive', isInteractive);
  };

  window.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse') {
      return;
    }

    targetX = event.clientX;
    targetY = event.clientY;
    cursor.classList.add('is-visible');
  }, { passive: true });

  window.addEventListener('pointerover', (event) => {
    setInteractive(Boolean(event.target?.closest?.(interactiveSelector)));
  }, { passive: true });

  window.addEventListener('pointerout', (event) => {
    if (!event.relatedTarget) {
      cursor.classList.remove('is-visible');
      setInteractive(false);
    }
  }, { passive: true });

  render();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCursor, { once: true });
} else {
  initCursor();
}
